<template>
  <div/>
</template>

<script>
export default {
  name: 'Outstanding',
  props: {
    value: {type:Boolean, required:true}
  }
}
</script>